export class TrackPlayerAPIClientError extends Error {
    /**
     * Represents a dealer error.
     *
     * @param code - The error code.
     * @param message - The error message.
     * @param status - The status number.
     * @param debug - Helper object for debugging.
     */
    constructor(code, message) {
        super(message);
        /**
         * The status of the response from the tp-service that caused the error to
         * be created.
         */
        this.status = -1;
        /**
         * Will be true if max subscriptions is (ie. response from the tp-service
         * has http status 429) reached.
         */
        this.maxedSubscriptions = false;
        /**
         * Will be set to `true` if the severity of the error is such that the
         * player can't recover from it - for example when it's sprung from the
         * platform not supporting the required technologies.
         */
        this.unrecoverable = false;
        /**
         * Object for storing properties of an event that's usefull for debugging.
         */
        this.debug = {};
        this.registration = false;
        this.code = code;
        this.name = 'TrackPlayerAPIClientError';
    }
    /**
     * Sets the unrecoverable function to `true`.
     *
     * @param code - The error code.
     * @param message - The error message.
     * @return PlayerAPIClient error
     */
    static fatal(code, message) {
        const error = new TrackPlayerAPIClientError(code, message);
        error.unrecoverable = true;
        return error;
    }
}
//# sourceMappingURL=client.js.map